export default __webpack_public_path__ + "static/media/green.a407a62b.png";